import { css } from '@emotion/react'
import {
  DesignToken,
  SpacingToken,
  Text,
} from '@livechat/design-system-react-components'

import { PAYMENT } from '@/constants'
import { formatPrice } from '@/utils/products'

const priceFrequencyCss = css`
  color: var(${DesignToken.ContentBasicSecondary});
  margin-left: var(${SpacingToken.Spacing1});
`

interface Props {
  value?: number
  frequency?: string
  months?: number
}

const PriceFormatter = ({ value, frequency, months = 1 }: Props) => {
  if (!value) {
    return null
  }

  const formattedValue = formatPrice(value, true)

  return (
    <span>
      ${formattedValue}
      {frequency && ![PAYMENT.FREQUENCY.ONCE].includes(frequency) && (
        <Text css={priceFrequencyCss} as="span" size="sm">
          {months === 1 && '/mo'}
          {months === 12 && '/yr'}
        </Text>
      )}
    </span>
  )
}

export default PriceFormatter
